//codex-- Keep System Config section selection in the route, including mobile/back navigation.
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import PageToolbar from './PageToolbar';
import SideNav from '../components/SideNav';
import HeadingCp from '../components/HeadingCp';
import ButtonConfigCp from '../components/ButtonConfigCp';
import FullSchedulerConfigCp from '../components/FullSchedulerConfigCp';
import BookmarksConfigCp from '../components/BookmarksConfigCp';
const tabs = [{ key: 'button_config', label: 'Favorite Buttons' }, { key: 'bookmarks', label: 'Bookmarks' }];
export default function SystemPage() {
  const { key } = useParams();
  const navigate = useNavigate();
  const active = key === 'bookmarks' ? 'bookmarks' : 'button_config';
  return <div className="mx-auto grid max-w-[1220px] grid-cols-1 gap-x-4 md:grid-cols-[200px_minmax(0,_1fr)]">
    <div className="hidden pt-6 pr-3 md:block"><SideNav /></div>
    <div className="min-w-0 mt-10 p-4">
      <HeadingCp label="System Config" />
      <PageToolbar title="Page navigation" actions={<>
        <label className="sm:hidden"><span className="sr-only">System Config section</span><select value={active} onChange={(e) => navigate(`/system_config/${e.target.value}`)} className="rounded-md border-gray-300 text-sm">{tabs.map((tab) => <option key={tab.key} value={tab.key}>{tab.label}</option>)}</select></label>
        <nav aria-label="System Config sections" className="hidden gap-4 sm:flex">{tabs.map((tab) => <NavLink key={tab.key} to={`/system_config/${tab.key}`} className={`border-b-2 px-1 py-3 text-sm font-medium ${active === tab.key ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500'}`} aria-current={active === tab.key ? 'page' : undefined}>{tab.label}</NavLink>)}</nav>
      </>} />
      <div className="mt-6">{active === 'bookmarks' ? <BookmarksConfigCp /> : <><ButtonConfigCp /><FullSchedulerConfigCp /></>}</div>
    </div>
  </div>;
}
